export const HEADER_SESSION_ID = 'X-Session-Id';
export const HEADER_TRACE_ID = 'X-Trace-Id';

export function generateTraceId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return `req_${crypto.randomUUID()}`;
  }
  return `req_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
}

/**
 * 为 axios 请求注入 sessionId / traceId 请求头，并写入 config.metadata 供响应侧使用。
 */
export function applyTracingHeaders(config, sessionId, traceId) {
  if (!config.headers) {
    config.headers = {};
  }
  if (typeof config.headers.set === 'function') {
    config.headers.set(HEADER_SESSION_ID, sessionId);
    config.headers.set(HEADER_TRACE_ID, traceId);
  } else {
    config.headers[HEADER_SESSION_ID] = sessionId;
    config.headers[HEADER_TRACE_ID] = traceId;
  }

  config.metadata = {
    ...(config.metadata || {}),
    sessionId,
    traceId,
    startTime: Date.now(),
  };

  return config;
}
